import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import TermEditForm from 'components/TermEditForm';

import { withData } from 'lib';
import { SettingsTermEditPageQuery } from '__generated__/SettingsTermEditPageQuery.graphql';

const query = graphql`
  query SettingsTermEditPageQuery($id: ID!) {
    term(id: $id) {
      name

      ...EntitySidebar_entity
      ...TermEditForm_term
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsTermEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/terms', name: 'Įskaičiuota į kainą' },
];

const SettingsTermEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { term } = usePreloadedQuery<SettingsTermEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!term) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={term} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: term.name,
        },
      ]}>
      <TermEditForm term={term} />
    </PageWithSidebar>
  );
};

export default withData<SettingsTermEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsTermEditPage);
